<template>
  <div class="navbar">

    <EditAccountModal v-if="showAccountModal"></EditAccountModal>
    <DeclarationModal v-if="showDeclarationModal"></DeclarationModal>
    <HistoryModal v-if="showHistoryModal"></HistoryModal>
    <CloneDeclarationModal v-if="showCloneDeclarationModal"></CloneDeclarationModal>
    <MoveDeclarationModal v-if="showMoveDeclarationModal"></MoveDeclarationModal>

    <div id="declaration-type-modal" v-if="newDeclarationModal">
      <h4>
        Dodaj Deklarację
      </h4>

      <label>
        <input
          value="A"
          type="radio"
          v-model="declarationType"
        />
        Budynki i lokale mieszkalne
      </label>

      <label>
        <input
          value="B"
          type="radio"
          v-model="declarationType"
        />
        Budynki i lokale niemieszkalne
      </label>

      <b-form-select
        v-model="buildingData"
        :options="buildingsFormatted"
        :select-size="4"
      />
      <div style="flex-direction: row-reverse;display: flex;">
        <button
          type="button"
          class="btn btn-primary"
          @click="openDeclarationModal"
          v-if="(buildingData != null)"
        >
          Dodaj deklarację
        </button>
        <button
          type="button"
          class="btn btn-primary disabled"
          v-if="(buildingData == null)"
          title="Nie wybrano budynku"
          @click="showNoBuilding"
        >
          Dodaj deklarację
        </button>
        <button type="button" class="btn btn-link" @click="newDeclarationModal = false">
          Anuluj
        </button>
      </div>
    </div>

    <div class="navbar-container">
    {{ declarationVerification }}

      <div class="navbar-element" id="add-building-button">

        <a v-if="route === 'buildings'" @click="openBuildingsModal">
          <zone-icon icon-name="Plus"/>
          <label class="menu-link small-on-xs">Dodaj Budynek</label>
        </a>

        <a v-if="route === 'declarations'" @click="openNewDeclarationModal">
          <b-spinner v-if="buildings === null" label="Wczytuję" variant="secondary" style="width: 1.7em; height:1.7em"></b-spinner>
          <zone-icon v-if="buildings !== null" icon-name="Plus"/>
          <label class="menu-link small-on-xs">Dodaj Deklarację</label>
          <div class="menu-link d-none d-md-block" style="font-size: small; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 5px">
            Tylko dla 10 ostatnio dodanych adresów budynków. W innym wypadku przejdź do zakładki <i>Budynki</i>.
          </div>
        </a>

        <div v-if="(route === 'verify') || (route === 'verifyfull')">
          <h2 style="color: #202f64">Sprawdź swoją deklarację</h2>
        </div>

      </div>

      <div class="navbar-element" v-if="isUserLogged">
        <a class="user-panel"
           type="button"
           tabindex="0"
           href="#"
           @click.prevent="openUserActionsDropdown"
           @keydown.enter="openUserActionsDropdown"
        >
          <label class="menu-link d-none d-sm-inline">{{ currentUserData.full_name }}</label>
          <zone-icon icon-name="User1"/>
          <div v-if="userActionsModal" @mousemove="openUserActionsDropdown"
               class="dropdown-menu show user-actions-dropdown">
            <a class="dropdown-item" href="#" @click="openAccountModal">Ustawienia konta</a>
            <a class="dropdown-item" href="#" @click="logout">Wyloguj</a>
          </div>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import UsersModel from "@/models/users";
import EditAccountModal from "@/components/users/EditAccountModal";
import ZoneIcon from "@/components/common/ZoneIcon";
import DeclarationModal from "@/components/declarations/DeclarationModal";
import LocationsModel from "@/models/locations";
import HistoryModal from "@/components/declarations/HistoryModal";
import CloneDeclarationModal from "@/components/declarations/CloneDeclarationModal";
import MoveDeclarationModal from "@/components/declarations/MoveDeclarationModal";


export default {
  name: "Navbar",
  components: {DeclarationModal, ZoneIcon, HistoryModal, EditAccountModal, CloneDeclarationModal, MoveDeclarationModal},
  data() {
    return {
      newDeclarationModal: false,
      userActionsModal: false,
      declarationType: 'A',
      buildings: [],
      buildingData: null
    }
  },
  computed: {
    route() {
      return this.$route.name;
    },
    showAccountModal() {
      return this.$store.state.showAccountModal;
    },
    showDeclarationModal() {
      return this.$store.state.showDeclarationModal;
    },
    showHistoryModal() {
      return this.$store.state.showHistoryModal;
    },
    showCloneDeclarationModal() {
      return this.$store.state.showCloneDeclarationModal;
    },
    showMoveDeclarationModal() {
      return this.$store.state.showMoveDeclarationModal;
    },
    currentUserData() {
      return this.$store.state.currentUserData;
    },
    isUserLogged() {
      return ((this.$store.state.currentUserData) && ('pesel' in this.$store.state.currentUserData) && (this.$store.state.currentUserData.pesel));
    },
    buildingsFormatted() {
      let result = [];
      if (this.buildings !== null) {
        this.buildings.forEach((building) => {
          result.push({
            value: building,
            text: building.formatted_address
          });
        })
      }
      return result;
    },
    declarationVerification() {
      return this.$store.state.declarationVerification;
    },
    declarationVerificationFull() {
      return this.$store.state.declarationVerificationFull;
    },
  },
  methods: {
    async openNewDeclarationModal() {
      await this.getBuildings();
      this.newDeclarationModal = true;
    },
    getBuildings() {
      this.buildings = null;
      return LocationsModel.getUserBuildings()
        .then((res) => this.buildings = res.data);
    },
    openDeclarationModal() {
      this.buildingData.declarationType = this.declarationType;
      this.$store.commit("setDeclarationBuilding", this.buildingData);
      this.$store.commit("openDeclarationModal");
      this.newDeclarationModal = false;
    },
    openAccountModal() {
      this.userActionsModal = false;
      this.$store.commit("openAccountModal");
    },
    openBuildingsModal() {
      this.userActionsModal = false;
      this.$store.commit("openBuildingsModal");
    },
    openUserActionsDropdown() {
      this.userActionsModal = true;
    },
    closeUserActionsDropdown(e) {
      if (!this.$el.contains(e.target) || Array.from(this.$el.children).includes(e.target)) {
        this.userActionsModal = false;
      }
    },
    closeDeclarationVerification() {
      this.$store.commit("setDeclarationVerification", null);
    },
    closeDeclarationVerificationFull() {
      this.$store.commit("setDeclarationVerificationFull", null);
    },
    showNoBuilding() {
      if (this.buildings.length == 0) {
        this.$notify({
          group: 'zone',
          type: 'error',
          title: 'Błąd',
          text: 'Aby dodać deklarację, najpierw dodaj budynek w zakładce Budynki.'
        });
      } else {
        this.$notify({
          group: 'zone',
          type: 'error',
          title: 'Błąd',
          text: 'Wybierz adres, dla którego chcesz złożyć deklarację.'
        });
      }
    },
    async logout() {
      try {
        const res = await UsersModel.logout();
        setTimeout(() => document.getElementById("redirect_to_logout_page").click(), 1000);
        document.body.innerHTML = res.data;
      } finally {
        this.userActionsModal = false;
      }
    }
  },
  watch: {
    route(newValue, oldValue) {
      if (oldValue === "declarations") {
        this.newDeclarationModal = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.closeUserActionsDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeUserActionsDropdown);
  }
}
</script>

<style scoped>
.navbar {
  z-index: 9;
  position: fixed;
  left: 17.3em;
  right: 0;
  background-color: #fff;
  height: 5.5em;
  -webkit-box-shadow: 0 8px 6px -6px #0000002e;
  -moz-box-shadow: 0 8px 6px -6px #0000002e;
  box-shadow: 0 8px 6px -6px #0000002e;
}

#declaration-type-modal h4 {
  font-size: 1.6rem;
  letter-spacing: .025rem;
  color: #202f64;
}

#declaration-type-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  width: 30vw;
  background-color: #FFFFFF;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 2px 10px 4px #0000001a;
}


#declaration-type-modal .btn {
  margin-top: 1rem;
  width: 30%;
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.navbar-element {
  height: 100%;
  padding: 1.5rem;
}

.navbar-element label {
  padding: 0 1rem;
  font-family: "Volte Semibold", serif;
  color: #6e7182;
  cursor: pointer;
  vertical-align: middle;
}


@media screen and (max-width: 768px) {
  .navbar {
    left: 0;
    top: 3em;
  }

  #declaration-type-modal {
    width: 96%;
  }

  .navbar-element {
    height: 100%;
    padding-left: 0.2em;
    padding-right: 0.2em;
  }

  .navbar-element label.small-on-xs {
    font-size: 90%;
  }
}

.zone-icon {
  width: 1.7rem;
  height: 1.7rem;
}

.user-actions-dropdown {
  right: 2rem;
  top: 4rem;
  left: unset !important;
}

#add-building-button {
  cursor: pointer;
  max-width: 67%;
}

.btn-primary.disabled, .btn-primary.disabled:hover {
  background: #6c757d !important;
  cursor: not-allowed;
}

.navbar-element:hover .menu-link, .navbar-element:hover .zone-icon {
  color: #202f64;
  -webkit-filter: grayscale(100%) brightness(30%) sepia(100%) hue-rotate(-180deg) saturate(700%) contrast(0.8);
  filter: grayscale(100%) brightness(30%) sepia(100%) hue-rotate(-180deg) saturate(700%) contrast(0.8);
}

.zone-modal {
  height: 10rem;
}

@media screen and (max-width: 768px) {
  .zone-modal {
    -webkit-transform: none;
    transform: none;
    position: absolute;
    top: -80px;
    left: 10px;
    right: 10px;
    height: auto;
    width: auto;
  }

  .zone-modal .postal-code-input {
    margin-bottom: 0.8rem;
  }
}

.zone-modal .buttons-row {
  margin-top: 0;
}

</style>
